import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AGentleGoodbye() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll();
  const {
    ref: subRef,
    isVisible: isSubVisible
  } = useRevealOnScroll();
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll();
  return <section data-section-id="18435" id="welcome-to-ai-looks-at-ai" className="dark bg-primary text-white relative h-[600px] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-transparent opacity-0 bg-cover bg-center" />

      {}
      <div className="absolute inset-0 bg-transparent" />

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <div className="flex flex-col items-center gap-6">
          {}
          <h2 ref={subRef} className={cn("font-sans text-[19px] leading-relaxed text-white transition-all duration-1000 ease-out transform", isSubVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
            Exploring the rapid evolution of machine intelligence and its profound impact on the future of modern web development.
          </h2>

          {}
          <h1 ref={titleRef} className={cn("font-sans text-4xl font-extrabold text-white md:text-[48px] tracking-tighter leading-tight transition-all duration-1000 delay-200 ease-out transform", isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            Welcome to 'AI looks at AI'
          </h1>

          {}
          <div ref={btnRef} className={cn("mt-2 transition-all duration-1000 delay-400 ease-out transform", isBtnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <Button asChild className="h-auto rounded-full border border-white bg-transparent px-8 py-4 text-base font-bold text-chart-3 animate-pulse transition-all hover:-translate-y-0.5 hover:bg-white/10 hover:shadow-xl">
              <Link to="/HomePage">TOP</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}